// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__fas-u","pillsContainer":"styles_pillsContainer__afCkb","allCoursesText":"styles_allCoursesText__uSQio"};